// 개인 프로파일 부가 정보 — 혈액형·MBTI. 프로파일 JSON(EmployeeProfiles/<upn>.json)에 함께 저장.
// MBTI 확인하기는 공식 검사(MBTI®)가 아닌 사내용 간이 성격유형 자가 점검이다.
export const BLOOD_TYPES = ['A', 'B', 'O', 'AB'];
export const MBTI_RE = /^[EI][SN][TF][JP]$/;
// 축마다 10문항(업무·일상 상황). 축의 첫 문항이 대표 문항 — 5:5 동점이면 대표 문항 쪽으로 판정
export const MBTI_QUESTIONS = [
    { axis: 'EI', q: '새 프로젝트 첫 회의에서 나는', a: '먼저 말을 꺼내며 분위기를 띄운다', b: '듣고 정리한 뒤 필요한 말을 한다' },
    { axis: 'EI', q: '일이 막힐 때 나는', a: '동료와 이야기하며 풀어 본다', b: '혼자 차분히 생각하며 정리한다' },
    { axis: 'EI', q: '회식이나 행사 뒤 나는', a: '오히려 기운이 난다', b: '조용히 쉬어야 회복된다' },
    { axis: 'EI', q: '처음 만난 고객사 담당자와', a: '금방 편하게 대화한다', b: '시간이 지나야 편해진다' },
    { axis: 'EI', q: '업무 공유는', a: '말로 바로 나누는 편이 좋다', b: '글로 정리해 공유하는 편이 좋다' },
    { axis: 'EI', q: '점심시간에 나는', a: '여럿이 함께 먹으며 이야기하는 게 좋다', b: '혼자나 소수와 조용히 보내는 게 좋다' },
    { axis: 'EI', q: '아이디어가 떠오르면', a: '바로 사람들에게 말하며 다듬는다', b: '혼자 충분히 다듬은 뒤 꺼낸다' },
    { axis: 'EI', q: '주말을 보내는 방식은', a: '약속을 잡고 사람들을 만난다', b: '집이나 익숙한 곳에서 쉰다' },
    { axis: 'EI', q: '전화와 메신저 중', a: '통화로 빨리 해결하는 편이 편하다', b: '메신저로 생각을 정리해 보내는 편이 편하다' },
    { axis: 'EI', q: '사람들은 나를', a: '활발하고 말이 많은 편이라고 한다', b: '차분하고 신중한 편이라고 한다' },
    { axis: 'SN', q: '업무 지시를 받으면', a: '구체적인 절차와 예시가 있으면 좋다', b: '목적과 큰 방향만 알면 된다' },
    { axis: 'SN', q: '보고서를 쓸 때 나는', a: '사실과 수치를 꼼꼼히 담는다', b: '의미와 앞으로의 가능성을 강조한다' },
    { axis: 'SN', q: '새 기술을 배울 때', a: '따라 해 보며 하나씩 익힌다', b: '원리와 전체 구조부터 이해한다' },
    { axis: 'SN', q: '나는 대체로', a: '현재 해야 할 일에 집중한다', b: '앞으로 할 수 있는 일을 떠올린다' },
    { axis: 'SN', q: '설명을 들을 때 더 와닿는 것은', a: '실제 사례와 경험', b: '비유와 아이디어' },
    { axis: 'SN', q: '문제를 풀 때 나는', a: '검증된 방법을 먼저 쓴다', b: '새로운 방법을 시도해 본다' },
    { axis: 'SN', q: '회의록을 보면 먼저 눈에 들어오는 것은', a: '날짜·담당자·수치 같은 세부 사항', b: '전체 흐름과 숨은 의도' },
    { axis: 'SN', q: '길을 안내할 때 나는', a: '“두 번째 신호등에서 우회전” 식으로 말한다', b: '“큰 건물 쪽으로 가다 보면” 식으로 말한다' },
    { axis: 'SN', q: '나에게 더 가까운 말은', a: '“눈으로 확인한 것만 믿는다”', b: '“직감이 맞을 때가 많다”' },
    { axis: 'SN', q: '반복 업무를 맡으면', a: '익숙해져 정확하게 처리할 수 있어 좋다', b: '금방 지루해져 개선 방법을 궁리한다' },
    { axis: 'TF', q: '의견이 부딪힐 때 나는', a: '논리와 근거로 판단한다', b: '사람들의 입장과 관계를 먼저 살핀다' },
    { axis: 'TF', q: '동료의 결과물에 피드백할 때', a: '고칠 점을 분명하게 말한다', b: '좋은 점부터 말하고 조심스럽게 전한다' },
    { axis: 'TF', q: '결정할 때 더 중요한 것은', a: '효율과 결과', b: '구성원의 만족과 공감' },
    { axis: 'TF', q: '칭찬받고 싶은 말은', a: '“정확하고 능력 있다”', b: '“배려심 있고 따뜻하다”' },
    { axis: 'TF', q: '고객 불만을 들으면', a: '원인과 해결책부터 찾는다', b: '고객의 기분을 먼저 헤아린다' },
    { axis: 'TF', q: '동료가 고민을 털어놓으면', a: '현실적인 해결책을 제시한다', b: '먼저 공감하고 들어준다' },
    { axis: 'TF', q: '평가를 할 때 나는', a: '기준을 똑같이 적용하는 것이 공정하다', b: '각자의 사정을 고려하는 것이 공정하다' },
    { axis: 'TF', q: '회의에서 반대 의견을 낼 때', a: '분위기보다 내용의 옳고 그름이 우선이다', b: '상대가 상처받지 않게 표현을 고른다' },
    { axis: 'TF', q: '영화나 드라마를 볼 때', a: '설정의 허점이 눈에 띈다', b: '인물의 감정에 쉽게 몰입한다' },
    { axis: 'TF', q: '팀원이 실수했을 때', a: '무엇이 잘못됐는지 짚고 재발을 막는다', b: '먼저 다독이고 함께 수습한다' },
    { axis: 'JP', q: '일정 관리는', a: '미리 계획을 세우고 따른다', b: '상황에 맞춰 유연하게 움직인다' },
    { axis: 'JP', q: '마감이 다가오면', a: '이미 여유 있게 끝내 둔 편이다', b: '막바지에 집중력이 오른다' },
    { axis: 'JP', q: '출장 준비는', a: '일정과 준비물을 미리 정리한다', b: '필요한 것만 챙기고 현장에서 맞춘다' },
    { axis: 'JP', q: '책상과 파일은', a: '정해진 자리에 정리해 둔다', b: '쓰기 편한 대로 둔다' },
    { axis: 'JP', q: '갑자기 일정이 바뀌면', a: '불편하고 다시 계획을 세운다', b: '괜찮다, 새로 맞추면 된다' },
    { axis: 'JP', q: '여행을 갈 때 나는', a: '숙소·동선·맛집까지 미리 정한다', b: '큰 틀만 정하고 가서 정한다' },
    { axis: 'JP', q: '할 일 목록은', a: '꼭 적어 두고 하나씩 지운다', b: '머릿속으로 대략 기억한다' },
    { axis: 'JP', q: '결정을 내릴 때', a: '빨리 정하고 다음으로 넘어간다', b: '정보를 더 모으며 여지를 둔다' },
    { axis: 'JP', q: '업무를 시작할 때', a: '순서를 정하고 차례대로 한다', b: '손에 잡히는 것부터 동시에 진행한다' },
    { axis: 'JP', q: '약속 시간에는', a: '보통 미리 도착한다', b: '딱 맞추거나 조금 늦기도 한다' },
];
/** 답(문항별 'a'|'b') → 유형. 축마다 다수인 쪽 글자, 동점이면 그 축 첫(대표) 문항의 답 */
export function scoreMbti(answers) {
    const letters = { EI: ['E', 'I'], SN: ['S', 'N'], TF: ['T', 'F'], JP: ['J', 'P'] };
    return ['EI', 'SN', 'TF', 'JP'].map((axis) => {
        const idx = MBTI_QUESTIONS.map((q, i) => (q.axis === axis ? i : -1)).filter((i) => i >= 0);
        const aCount = idx.filter((i) => answers[i] === 'a').length;
        const first = aCount * 2 === idx.length ? answers[idx[0]] === 'a' : aCount * 2 > idx.length;
        return first ? letters[axis][0] : letters[axis][1];
    }).join('');
}
export const MBTI_DESCRIPTIONS = {
    ISTJ: '책임감 있고 체계적인 실무형', ISFJ: '성실하고 세심하게 돕는 수호형', INFJ: '통찰력 있고 신념이 뚜렷한 옹호형', INTJ: '전략적이고 독립적인 설계형',
    ISTP: '침착하고 문제 해결에 강한 장인형', ISFP: '온화하고 유연한 예술가형', INFP: '이상과 가치를 중시하는 중재형', INTP: '분석적이고 호기심 많은 사색형',
    ESTP: '현장 감각이 뛰어난 활동형', ESFP: '밝고 분위기를 이끄는 사교형', ENFP: '열정적이고 아이디어가 많은 활동가형', ENTP: '도전적이고 토론을 즐기는 발명가형',
    ESTJ: '조직적이고 추진력 있는 관리자형', ESFJ: '협조적이고 배려 깊은 친선형', ENFJ: '사람을 이끄는 따뜻한 리더형', ENTJ: '결단력 있는 지휘관형',
};
//# sourceMappingURL=personality.js.map